// Import des styles
import "../sass/style";

// Import Locomotive scroll Library
// import LocomotiveScroll from "locomotive-scroll";

import { showMouse, hideMouse } from "./mouse/mouse";
import "./callNoCall/call";
import "./menuNavigation/navigationResponsive";
import "./searchForm/searchForm";

document.addEventListener("DOMContentLoaded", () => {
  showMouse();

  window.addEventListener("scroll", (event) => {
    if (window.scrollY > 150) {
      hideMouse();
    } else {
      showMouse();
    }
  });
  /* 
  // Locomotive scroll -- Pour l'instant, beaucoup de contraintes techniques et ne prend pas en charge
  // Les suivis sur Clarity, dommage...
  const isLocomotive = document.querySelector("[data-scroll-container]");
  if (isLocomotive) {
    const scroll = new LocomotiveScroll({
      el: document.querySelector("[data-scroll-container]"),
      smooth: true,
    });

    scroll.update();

    scroll.on("scroll", (args) => {
      if (args.delta.y >= 100) {
        hideMouse();
      } else {
        showMouse();
      }
    });

    const anchorLinks = document.querySelectorAll(
      "a[href^=\\#]:not([href$=\\#])"
    );
    anchorLinks.forEach((anchorLink) => {
      let hashval = anchorLink.getAttribute("href");
      let target = document.querySelector(hashval);

      anchorLink.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();

        scroll.scrollTo(target);
      });
    });
  }*/
});
